import React from 'react';

export const HeroSection = ({
  user,
  gallery,
  activeGallery,
  setActiveGallery,
  onGoToDashboard,
  onViewProjects
}) => {
  return (
    <section className="relative min-h-screen flex items-end pb-20 overflow-hidden">
      {/* Background slideshow */}
      {gallery.map((item, i) => (
        <div
          key={item.id}
          className="absolute inset-0 transition-opacity duration-1000"
          style={{ opacity: i === activeGallery ? 1 : 0 }}
        >
          <img
            src={`/kitchens/${item.id}.jpg`}
            alt={item.label}
            className="w-full h-full object-cover object-center"
          />
        </div>
      ))}

      {/* Dark gradient overlays — kept light so kitchen photos stay visible */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/20 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/30 to-transparent" />

      {/* Hero Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full">
        <div className="max-w-2xl">
          <p className="text-[11px] font-bold tracking-[0.3em] text-amber-400 uppercase mb-4 font-sans">
            Admin Portal
          </p>
          <h1 className="text-5xl md:text-7xl font-serif font-medium text-white leading-[1.1] tracking-tight mb-6">
            Welcome Back,<br />
            <span className="italic font-light">{user?.name || 'User'}</span>
          </h1>
          <p className="text-slate-300 text-lg leading-relaxed mb-10 max-w-lg font-light">
            Manage your projects, team, and operations from one centralized dashboard.
          </p>
          {/* Developer : Nithin
              Date : 26-06-2026
              Changes : Commented out navigation buttons for 'just for display' home layout.
          <div className="flex flex-wrap gap-4">
            <button
              onClick={onGoToDashboard}
              className="bg-white text-slate-900 font-semibold px-7 py-3.5 rounded-xl hover:bg-slate-100 transition-all duration-200 text-sm tracking-wide active:scale-[0.98]"
            >
              Go to Dashboard
            </button>
            <button
              onClick={onViewProjects}
              className="border border-white/40 text-white font-medium px-7 py-3.5 rounded-xl hover:bg-white/10 transition-all duration-200 text-sm tracking-wide active:scale-[0.98]"
            >
              View Projects
            </button>
          </div>
          */}
        </div>

        {/* Gallery dots indicator */}
        <div className="flex items-center gap-2 mt-12">
          {gallery.map((item, i) => (
            <button
              key={i}
              onClick={() => setActiveGallery(i)}
              className={`transition-all duration-300 rounded-full ${i === activeGallery ? 'w-8 h-2 bg-white' : 'w-2 h-2 bg-white/40 hover:bg-white/60'}`}
            />
          ))}
          <span className="ml-3 text-[10px] font-bold tracking-widest text-white/50 uppercase font-sans">
            {gallery[activeGallery]?.label}
          </span>
        </div>
      </div>
    </section>
  );
};
